<template>
    <div>
        <div class="header">
            <div class="back" @click="back()">
                <span class="icon-dropdown_up"></span>
                indietro
            </div>
            <div class="sf2__title--left-stroke title--xs">Come vuoi pagare e <br><strong>ricevere la bolletta?</strong></div>
        </div>

        <p>
            Attiva l'<strong>Addebito su conto corrente</strong> e la <strong>Bolletta digitale</strong> per ricevere lo <strong>Sconto Digitale del 10%</strong> sui corrispettivi per 24 mesi. Con l’Addebito sul conto corrente non dovrai lasciare un deposito cauzionale.
        </p>

        <radioBox class="small-label column" :question="payment.question" :items="payment.items" :default="payment.current"  @changed="onChange" />
        
        <div v-if="this.digital==true && this.bollettino==false" class="ok"><span class="icon-check"></span> SCONTO DIGITALE 10%</div>
        <div v-if="this.digital!=true || this.bollettino!=false" class="ko"><span class="icon-plus"></span> SCONTO DIGITALE 10%</div>

        <div class="lock-down">
            <button class="sf2-btn" @click="next()">Continua</button>
        </div>
    </div>
</template>

<script>

    import RadioBox from '../../../elements/RadioBox.vue';

    export default {
        name: "Payment",
        components: {
            RadioBox
        },
        props: {
        },
        data() {
            return {
                bollettino: false,
                digital: true,
                payment: {
                    question: '',
                    current: "addebito+digitale",
                    items: [
                        { 
                            "label": "Bollettino postale + bolletta cartacea",
                            "value": "bollettino+cartacea",
                            "class": "longText"
                        }, {
                            "label": "Addebito su conto + bolletta cartacea",
                            "value": "conto+cartacea",
                            "class": "longText"
                        }, {
                            "label": "Addebito su conto + bolletta digitale",
                            "value": "addebito+digitale",
                            "class": "longText"
                        }
                    ]
                }
            };
        },
        mounted() {
            console.log('Payment mounted');
        },
        computed: {

        },
        methods: {
            onChange( payment ) {
                console.log( 'Payment onChange', payment.val );
            
                this.digital = payment.val == 'addebito+digitale';
                this.bollettino = payment.val == 'bollettino+cartacea';
            },

            next() {
                console.log( 'Payment emit onNext' );

                this.$emit( 'onNext', {
                    'digital': this.digital,
                    'bollettino': this.bollettino
                } );
            },

            back() {
                console.log( 'Payment emit onBack' );

                this.$emit( 'onBack', 1 );
            }
        },
    };
</script>

<style scoped lang="scss">

    .sf2__title--left-stroke { margin-bottom: 30px; }

    .icon-plus {transform: rotate(45deg);}

    .ok { color: #7fa545; text-align: center; margin-top: 15px; font-weight: bold;}
    .ko { color: #767676; text-align: center; margin-top: 15px; font-weight: bold;
        span {transform: rotate(90deg);}
    }

    @media (max-width: 767px) {
        /deep/ .longText {
            padding-left: 60px; padding-right: 60px; line-height: 16px;
        }
    }

    button {margin-top: 30px;}

</style>